import React from 'react';
import { Search, ChevronLeft } from 'lucide-react';
import { clsx } from 'clsx';
import { Location, Finding, Rarity } from '@stalker/core';
import { ROOM_NAMES } from '#entities/location/index.js';
import { RARITY_ENUM_TO_COLOR } from '#shared/config/colors.js';

interface RoomPageProps {
  selectedRoom: Location;
  handlePickItem: (item: Finding) => void;
  goBack: () => void;
  getItemEmoji: (typeId: string) => string;
  getItemName: (typeId: string) => string;
}

export const RoomPage: React.FC<RoomPageProps> = ({
  selectedRoom,
  handlePickItem,
  goBack,
  getItemEmoji,
  getItemName,
}) => {
  return (
    <div className="animate-in fade-in scale-95 duration-500 max-w-3xl mx-auto">
      <div className="bg-card border border-border rounded-sm p-6 md:p-10 text-center relative overflow-hidden terminal-card">
        <button
          onClick={goBack}
          className="absolute top-3 left-3 md:top-4 md:left-4 group flex items-center gap-2 text-[10px] md:text-xs font-black uppercase tracking-[0.2em] text-primary bg-background/80 px-3 py-1.5 backdrop-blur-sm border border-border/50 hover:bg-primary hover:text-primary-foreground transition-all shadow-xl z-20"
        >
          <ChevronLeft size={14} className="group-hover:-translate-x-1 transition-transform" /> Назад
        </button>
        <div className="absolute inset-0 bg-gradient-to-b from-primary/[0.05] to-transparent pointer-events-none" />

        <div className="relative z-10">
          <div className="w-20 h-20 rounded-sm bg-primary/10 border border-primary/20 flex items-center justify-center text-primary mx-auto mb-8 rust-glow">
            <Search size={40} />
          </div>
          <h2 className="text-[10px] font-black uppercase tracking-[0.4em] text-muted-foreground mb-2">Сканирование области</h2>
          <h1 className="text-3xl font-black uppercase tracking-tight text-foreground mb-4">
            {ROOM_NAMES[selectedRoom.id.toString().split('_').pop() || ''] || selectedRoom.id.toString().split('_').pop()}
          </h1>
          <p className="text-muted-foreground text-sm mb-12 max-w-md mx-auto leading-relaxed italic">
            Анализаторы активны. Поиск артефактов и ценных ресурсов в текущем секторе...
          </p>

          <div className="space-y-4 text-left">
            {selectedRoom.getFindings().length > 0 ? (
              selectedRoom.getFindings().map(item => (
                <div
                  key={item.id.toString()}
                  className="p-5 rounded-sm border border-border bg-input/30 backdrop-blur-sm flex justify-between items-center group hover:bg-input/50 transition-colors animate-in slide-in-from-bottom-2 duration-500"
                >
                  <div className="flex items-center gap-4">
                    <div className={clsx(
                      "w-12 h-12 rounded-sm bg-background flex items-center justify-center border-2 text-2xl shadow-inner transition-transform group-hover:scale-110 duration-300",
                      RARITY_ENUM_TO_COLOR[item.rarity] || "border-border"
                    )}>
                      {getItemEmoji(item.typeId)}
                    </div>
                    <div>
                      <div className={clsx(
                        "text-[10px] font-black uppercase tracking-widest",
                        RARITY_ENUM_TO_COLOR[item.rarity]
                      )}>
                        {Rarity[item.rarity]} discovery
                      </div>
                      <div className="text-base font-bold uppercase text-foreground">
                        {getItemName(item.typeId)}
                      </div>
                    </div>
                  </div>
                  <button
                    onClick={() => handlePickItem(item)}
                    className="px-6 py-2.5 bg-primary text-primary-foreground text-[10px] font-black uppercase rounded-sm hover:bg-primary/80 transition-all active:scale-95 shadow-lg"
                  >
                    В рюкзак
                  </button>
                </div>
              ))
            ) : (
              <div className="p-12 border-2 border-dashed border-border rounded-sm text-center opacity-30">
                <p className="text-[10px] uppercase font-black tracking-[0.3em]">Сектор пуст</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
